/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {browserHistory} from 'react-router';
import * as FormName from '../../../constants/formNameConstants';
import * as injurySummaryActions from '../../../actions/injurySummaryActions';
import * as pathConstants from '../../../constants/pathConstants';
import {
  searchForFormById,
  searchForInjurySummary
} from '../../../selectors/searchForForm';
import {searchForEstablishmentById} from '../../../selectors/searchForEstablishment';
import confirmFormIsValid from './InjurySummaryEditChecks';
import InjurySummaryForm from './InjurySummaryForm';
import {createInjurySummaryObject} from '../injurySummaryModel';
import * as injuryConstants from '../../../constants/InjurySummaryConstants';
import '../../../styles/injurySummary/injurySummary.css';
import EstablishmentSubmitModal from '../../establishment/EstablishmentSubmitModal';

export class InjurySummaryPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      injurySummary: Object.assign({}, this.props.injurySummary),
      formIsValid: this.props.injurySummaryId ? true : false,
      activeFields: [],
      errors: {},
      softErrors: {},
      showModal: false,
      isResubmit: false,
      isActive: false,
      numOfEstablishments: 0,
      resubmissionReason: '',
      submitDisabled: true
    };

    this.submitInjurySummary = this.submitInjurySummary.bind(this);
    this.enteringData = this.enteringData.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.cancelInjurySummary = this.cancelInjurySummary.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.redirect = this.redirect.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.hideSubmitPage = this.hideSubmitPage.bind(this);
    this.submitEstablishments = this.submitEstablishments.bind(this);
    this.enteringResubmissionReason = this.enteringResubmissionReason.bind(this);
  }

  componentDidMount() {

    if(this.props.injurySummaryLinks.length > 0){
      let linkFound = false;

      let injurySummary = this.props.injurySummary;
      this.props.injurySummaryLinks.forEach(link=>{
        let injSumLink = link;
        let lastCharUrl = injSumLink.lastIndexOf('/') + 1;
        let injSumLinkId = injSumLink.slice(lastCharUrl);
        if(injSumLinkId == injurySummary.id){
          linkFound = true;
        }
      });

      if(linkFound === false && this.props.injurySummary.id){
        browserHistory.push(pathConstants.pathToAccessDenied);
      }
    }
  }

  componentWillReceiveProps(nextProps) {

     if(nextProps.injurySummaryLinks[0] != this.props.injurySummaryLinks[0]){
        let injurySummary = nextProps.injurySummary;
        let injSumLink = nextProps.injurySummaryLinks[0];
        let lastCharUrl = injSumLink.lastIndexOf('/') + 1;
        let injSumLinkId = injSumLink.slice(lastCharUrl);

        if(injSumLinkId != injurySummary.id){
          browserHistory.push(pathConstants.pathToAccessDenied);
        }
     }

     if(this.props.establishments.length > 0 && !nextProps.establishment){
       browserHistory.push(pathConstants.pathToAccessDenied);
     }

     if(nextProps.establishment && nextProps.establishment.establishment_status==2){
       browserHistory.push(pathConstants.pathToPageNotFound);
     }

     if (this.props.injurySummary.id !== nextProps.injurySummary.id) {
       // Necessary to populate form when existing course is loaded directly.
       this.setState({injurySummary: Object.assign({}, nextProps.injurySummary)});
     }
  }

  enteringData(event) {
    event.preventDefault();
    const field = event.target.name;
    if(field === "totalOtherCases"){
      this.setActiveFields("numberOfCases");
    }
    if(field === "totalOtherIllnesses"){
      this.setActiveFields("injuryAndIllnessTypes");
    }
    let injurySummary = this.state.injurySummary;
    injurySummary[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({injurySummary: injurySummary});
    this.setState({formIsValid: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).errors});
    this.setState({softErrors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).softErrors});
  }

  handleClick(event) {
    let injurySummary = this.state.injurySummary;
    injurySummary.noInjuries = event.target.value;
    if (injurySummary['noInjuries'] == injuryConstants.NO_INJURIES) {
      injurySummary['totalDeaths'] = '0';
      injurySummary['totalDafwCases'] = '0';
      injurySummary['totalDjtrCases'] = '0';
      injurySummary['totalOtherCases'] = '0';
      injurySummary['totalDafwDays'] = '0';
      injurySummary['totalDjtrDays'] = '0';
      injurySummary['totalInjuries'] = '0';
      injurySummary['totalSkinDisorders'] = '0';
      injurySummary['totalRespiratoryConditions'] = '0';
      injurySummary['totalPoisonings'] = '0';
      injurySummary['totalHearingLoss'] = '0';
      injurySummary['totalOtherIllnesses'] = '0';
    }
    this.setState({injurySummary: injurySummary});
    this.setState({formIsValid: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).errors});
    this.setState({softErrors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).softErrors});
  }

  handleCheckboxClick() {
    this.setState({submitDisabled: !this.state.submitDisabled});
  };

  onBlur(event) {
    event.preventDefault();
    const field = event.target.name;
    if(field === "totalOtherCases"){
      this.setActiveFields("numberOfCases");
    }
    if(field === "totalOtherIllnesses"){
      this.setActiveFields("injuryAndIllnessTypes");
    }
    this.setActiveFields(field);
    this.setState({formIsValid: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).errors});
    this.setState({softErrors: confirmFormIsValid(this.state.injurySummary, this.props.requiredFields, this.state.activeFields).softErrors});
  }

  setActiveFields(field) {
    let activeFields = this.state.activeFields;
    if (activeFields.indexOf(field) == -1) {
      activeFields.push(field);
      this.setState({activeFields: activeFields});
    }
  }

  enteringResubmissionReason(event) {
    event.preventDefault();
    let resubmissionReason = event.target.value;
    this.setState({resubmissionReason: resubmissionReason});
  }

  submitInjurySummary(event) {
    event.preventDefault();
    this.setState({ showModal: true, submitDisabled: true });
    // const establishment = this.props.establishment;
    // this.setState({formIsValid: false});
    // this.props.actions.submitInjurySummaryData(
    //   establishment,
    //   this.state.injurySummary,
    //   this.props.injurySummaryId)
    //   .then((establishmentId) => {
    //     this.redirect(establishmentId);
    //   }).catch(error => {
    //   this.setState({formIsValid: true});
    //   throw(error);
    // });
  }

  submitEstablishments(event) {
    event.preventDefault();
    
    const establishment = this.props.establishment;
    this.setState({ formIsValid: false });
    this.props.actions.submitInjurySummaryData(
      establishment,
      this.state.injurySummary,
      this.props.injurySummaryId,
      this.state.resubmissionReason
    )
    .then((establishmentId) => {
      this.redirect(establishmentId);
      this.hideSubmitPage();
    }).catch(error => {
      this.setState({ formIsValid: true });
      throw(error);
    });
  }

  hideSubmitPage() {
    this.setState({ showModal: false });
  }

  cancelInjurySummary(event) {
    event.preventDefault();
    browserHistory.push(pathConstants.pathToEstablishmentsDashboardPage + '/' + this.props.establishment.id);
  }

  redirect(id) {
    if(this.props.injurySummaryId){
      browserHistory.push({
        pathname: pathConstants.pathToEstablishmentsDashboardPage +'/' + id,
        state: {
          successMsg: "InjurySummary",
          newSummary: false
        }
      });
    } else{
      browserHistory.push({
        pathname: pathConstants.pathToEstablishmentsDashboardPage +'/' + id,
        state: {
          successMsg: "InjurySummary",
          newSummary: true
        }
      });
    }
  }

  render() {
    return (
      <div>
      {this.state.message}
      {this.props.user && <InjurySummaryForm
        form={this.props.injurySummaryForm}
        onChange={this.enteringData}
        establishment={this.props.establishment}
        onClick={this.handleClick}
        onSubmit={this.submitInjurySummary}
        onCancel={this.cancelInjurySummary}
        injurySummary={this.state.injurySummary}
        submitStatus={this.state.formIsValid}
        onBlur={this.onBlur}
        errors={this.state.errors}
        softErrors={this.state.softErrors}
      />}
      <EstablishmentSubmitModal
      showModal={this.state.showModal}
      onHide={this.hideSubmitPage}
      submitForm={this.props.submitForm}
      isResubmit={this.state.isResubmit}
      isActive={this.state.submitDisabled}
      numberOfEstablishments={1}
      resubmissionReason={this.state.resubmissionReason}
      onSubmit={this.submitEstablishments}
      onClick={this.handleCheckboxClick}
      onChange={this.enteringResubmissionReason}
      />
      </div>
    );
  }
}

InjurySummaryPage.propTypes = {
  actions: PropTypes.object.isRequired,
  establishment: PropTypes.object,
  establishments: PropTypes.array,
  injurySummaryId: PropTypes.string,
  injurySummary: PropTypes.object.isRequired,
  injurySummaryLinks: PropTypes.array.isRequired,
  injurySummaryForm: PropTypes.object.isRequired,
  requiredFields: PropTypes.array,
  user: PropTypes.object,
  submitForm: PropTypes.isRequired
};

function mapStateToProps(state, ownProps) {
  const establishmentId = ownProps.params.establishmentId;
  const establishments = state.establishments;
  const establishment =
    searchForEstablishmentById(establishments, establishmentId);
  const injurySummaryFormId = ownProps.params.injurySummaryFormId;
  let requiredFields = [];

  let injurySummary = {
    noInjuries: '',
    totalDeaths: '',
    totalDafwCases: '',
    totalDjtrCases: '',
    totalOtherCases: '',
    totalDafwDays: '',
    totalDjtrDays: '',
    totalInjuries: '',
    totalSkinDisorders: '',
    totalRespiratoryConditions: '',
    totalPoisonings: '',
    totalHearingLoss: '',
    totalOtherIllnesses: '',
    totalHoursWorked: '',
    annualAverageEmployees: '',
    id: injurySummaryFormId,
    establishment:{ id: establishmentId},
  };
  let injurySummaryForm = {};
  let submitForm = {};
  let injurySummaryLinks = [];
  if (establishment && establishment.links && establishment.links.form300a_links) {
    establishment.links.form300a_links.forEach(link => {
      injurySummaryLinks.push(link);
    });
  }
  if (state.forms.length > 0) {
    injurySummaryForm =
      searchForFormById(state.forms, FormName.itaInjurySummaryFormId);
      submitForm =
      searchForFormById(state.forms, FormName.itaSubmitModalId);
  }

  let retrievedSummary =
    searchForInjurySummary(state.injurySummaries, injurySummaryFormId);

  if (retrievedSummary) {
    injurySummary = createInjurySummaryObject(retrievedSummary);
    injurySummary.id = retrievedSummary.id;
    injurySummary.establishment = {id: establishmentId};
  }

  if (injurySummaryForm && injurySummaryForm.formQuestions) {
    requiredFields = [].concat.apply([], injurySummaryForm.formQuestions.map(question => {
      return question.questionParts.map(questionPart => {
        return questionPart;
      }).filter(questionPart => {
        return questionPart;
      });
    }));
  }
  return {
    establishment: establishment,
    establishments: establishments,
    injurySummaryId: injurySummaryFormId,
    injurySummary: injurySummary,
    injurySummaryLinks: injurySummaryLinks,
    injurySummaryForm: injurySummaryForm,
    requiredFields,
    user: state.user[state.user.length - 1],
    submitForm
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(injurySummaryActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InjurySummaryPage);



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/InjurySummaryManagement/InjurySummaryPage.js
 **/